module.exports = __webpack_public_path__ + "static/media/Gradient-27 2_1.01f0220a.webm";